import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoginCandidateService } from '../../../../employee/service/login-candidate/login-candidate.service';
import { Message } from 'primeng/primeng';

@Component({
  selector: 'app-recover-password-candidate',
  templateUrl: './recover-password-candidate.component.html',
  styleUrls: ['./recover-password-candidate.component.scss']
})
export class RecoverPasswordCandidateComponent implements OnInit {

  public form: FormGroup;
  public email: string;
  public msgs: Message[] = [];

  constructor(
    public translate: TranslateService,
    public route: ActivatedRoute,
    private _router: Router,
    public fb: FormBuilder,
    public LoginCandidateService: LoginCandidateService,
  ) {
    this.translate.use('es');
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
        this.email = params.email;
      }
    );

    this.createForm(this.email);
  }

  createForm(email: any){
    email = this.email || '';

    this.form = this.fb.group({
      email: new FormControl(email, Validators.compose([ Validators.required, Validators.minLength(4), Validators.pattern('^[a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,15})$') ])),
    });
  }

  SendEmail(values) {
    this.LoginCandidateService.passwordRecovery(values)
      .subscribe(response => {
        this.translate.get('saved').subscribe((res: string) => {
          this.msgs = [];
          this.msgs.push( { severity: 'success', summary: 'El link para cambiar tu contraseña fue enviado a: ' + values.email } );
        });
        alert('El link para cambiar tu contraseña fue enviado a: ' + values.email + '.\nSI NO ENCUENTRAS EL MENSAJE, REVISA SPAM O CORREOS NO DESEADOS');
        // window.close();
      }, error => {
        let errorMsg = '';
        if ( error.status === 500 )
          errorMsg = 'Error';
        this.msgs = [];
        this.msgs.push( { severity: 'error', summary: 'Error al enviar el link, por favor verifica tus datos' } );
        alert('Error al enviar el link, por favor verifica tus datos');
      });
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/multi-login/components/login-candidate/recover-password-candidate/recover-password-candidate.component.ts